import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { useGridLogger } from "../../utils/useGridLogger.js";
import { useGridRegisterPipeProcessor } from "../../core/pipeProcessing/index.js";
import { gridPreferencePanelStateSelector } from "./gridPreferencePanelSelector.js";
export var preferencePanelStateInitializer = function(state, props) {
    var _props_initialState;
    var _props_initialState_preferencePanel;
    return _extends({}, state, {
        preferencePanel: (_props_initialState_preferencePanel = (_props_initialState = props.initialState) === null || _props_initialState === void 0 ? void 0 : _props_initialState.preferencePanel) !== null && _props_initialState_preferencePanel !== void 0 ? _props_initialState_preferencePanel : {
            open: false
        }
    });
};
/**
 * TODO: Add a single `setPreferencePanel` method to avoid multiple `setState`
 */ export var useGridPreferencesPanel = function(apiRef, props) {
    var _props_initialState;
    var logger = useGridLogger(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ var hidePreferences = React.useCallback(function() {
        apiRef.current.setState(function(state) {
            if (!state.preferencePanel.open) {
                return state;
            }
            logger.debug('Hiding Preferences Panel');
            var preferencePanelState = gridPreferencePanelStateSelector(state);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return _extends({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    var showPreferences = React.useCallback(function(newValue, panelId, labelId) {
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState(function(state) {
            return _extends({}, state, {
                preferencePanel: _extends({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            });
        });
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    useGridApiMethod(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ var stateExportPreProcessing = React.useCallback(function(prevState, context) {
        var // Always export if the panel was initialized
        _props_initialState;
        var preferencePanelToExport = gridPreferencePanelStateSelector(apiRef.current.state);
        var shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || ((_props_initialState = props.initialState) === null || _props_initialState === void 0 ? void 0 : _props_initialState.preferencePanel) != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) {
            return prevState;
        }
        return _extends({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        (_props_initialState = props.initialState) === null || _props_initialState === void 0 ? void 0 : _props_initialState.preferencePanel
    ]);
    var stateRestorePreProcessing = React.useCallback(function(params, context) {
        var preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) {
            apiRef.current.setState(function(state) {
                return _extends({}, state, {
                    preferencePanel: preferencePanel
                });
            });
        }
        return params;
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
    useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
};
